var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourseActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CAC83165-666C-4CF8-AB3F-F3D63E97DECC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---360-",
    transform: "translate(-536.000000, -158.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "course-1",
    transform: "translate(296.000000, 129.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "active-stage-copy",
    transform: "translate(241.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,14.7027281 C4.30421875,14.7027281 1.29728125,11.6960406 1.29728125,8.00000937 C1.29728125,4.30422812 4.3041875,1.29729062 8,1.29729062 C11.696,1.29729062 14.7027187,4.30419687 14.7027187,8.00000937 C14.7027187,11.6960094 11.696,14.7027281 8,14.7027281 M8,9.375e-06 C3.58875,9.375e-06 0,3.58875937 0,8.00000937 C0,12.4112594 3.58875,16.0000094 8,16.0000094 C12.41125,16.0000094 16,12.4112594 16,8.00000937 C16,3.58875937 12.41125,9.375e-06 8,9.375e-06",
    id: "Fill-3"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F88801",
    cx: 8,
    cy: 8,
    r: 3.73333333
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseActive);
export default __webpack_public_path__ + "static/media/course-active.1fd37b0d.svg";
export { ForwardRef as ReactComponent };